import { createAction } from 'redux-actions';
import { default as request } from 'utils/GraphQLClient';
import { CREATE_MIP_AML, QUERY_MIP_AML } from 'mxp-graphql-queries';
import { amlActionNames, sanitizeAmlPayload } from './constants';
import { initialMipAml } from '../mip/constants';
import { Dispatch } from 'redux';

// ------------------------------------
// Actions
// ------------------------------------
export const setIsPdfFlag: any = createAction('AML/SET_IS_PDF_FLAG');

export const isAmlLoading = createAction(amlActionNames.IS_LOADING);

export const isRenewal = createAction(amlActionNames.IS_RENEWAL);

// Client-only flag: the member submitted a fresh AML annual return in the current renewal session.
export const setRenewalAmlSubmitted = createAction(amlActionNames.SET_RENEWAL_AML_SUBMITTED);
export const resetRenewalAmlSubmitted = createAction(amlActionNames.RESET_RENEWAL_AML_SUBMITTED);

export const createAML: any = createAction(amlActionNames.CREATE_AML, (amlForms: any) => async () => {
  const response = await request(CREATE_MIP_AML, { aml: sanitizeAmlPayload(amlForms) });

  return response;
});

export const getAML: any = createAction(amlActionNames.GET_AML, () => async (dispatch: Dispatch) => {
  dispatch(isAmlLoading());
  return request(QUERY_MIP_AML).then((response: any) => {
    if (response?.getMipAml?.id) {
      return { ...response.getMipAml, success: true };
    }
    return { ...initialMipAml, success: false };
  });
});
